import actions from './actions'
import saga from '../../../GeneralListFunctions/sagaFactory'

export default () =>
  saga(
    actions,
    () => `v1/auth/role`,
    (state) => state.addUserRoleAll
  )
